import "./index.css";
import { Spinner } from "@/ui-kit";

export const PageSpinner = () => {
  return (
    <div className="page-spinner">
      <Spinner size="2xl" />
    </div>
  );
};
